import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
export default function ExpenseModalCard({
  index,
  item,
  ExpenseItemssArr,
  setExpenseItemssArr,
}) {
  console.log("item ", item);
  return (
    <Grid container sx={{ cursor: "pointer" }}>
      <Grid item xs={12} sx={{ display: "flex" }}>
        <Box
          component="p"
          sx={{
            marginY: "1px",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            borderBottom: "1px solid #7D7D7D",
          }}
        >
          <Box
            component="span"
            color="primary"
            sx={{
              fontWeight: 500,
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            {item?.description}
          </Box>
          <Box
            component="span"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: { xs: "40%", sm: "20%" },
            }}
          >
            <CurrencyRupeeIcon fontSize="10px" sx={{ marginRight: "10px" }} />
            <Typography
              sx={{
                fontWeight: 500,
                fontFamily: "'Montserrat', sans-serif",
                alignItems: "right",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // marginRight: "30px"
                // marginLeft: "10px",
              }}
            >
              {item?.amount?.toFixed(2)}
            </Typography>
            <DeleteIcon
              sx={{ color: "#01008B" }}
              onClick={() => {
                let arr = [...ExpenseItemssArr];
                arr.splice(index, 1);
                setExpenseItemssArr(arr);
              }}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
